<template>
    <div class="page-wrapper">
        <Heading :title="$t('new_account_title')" class="mb-5 text-center" :routeName="'vignette'"></Heading>
        <div class="container container-xs">
            <template v-if="status != 1">
                <div class="register-wrapper">
                    <div class="form-group">
                        <label for="newAccountEmail">{{ $t('label_email') }}</label>
                         <span class="invalid-feedback">
                            {{errorMsgs.email}}
                        </span>
                        <input dusk="newAccountEmail" type="email" class="form-control" v-model="email" @blur="validateEmail" @focus="clearErrors('email')" :class="{'has-error' : errorMsgs.email}" >
                    </div>
                    <div class="form-group">
                        <label for="newAccountPhone">{{ $t('label_phone') }}</label>
                         <span class="invalid-feedback">
                            {{errorMsgs.phone}}
                        </span>
                        <input dusk="newAccountPhone" type="tel" class="form-control" v-model="phone" @blur="validatePhone" @focus="clearErrors('phone')" :class="{'has-error' : errorMsgs.phone}" >
                    </div>
                    <div class="form-group">
                        <label for="newAccountPassword">{{ $t('label_password') }}</label>
                        <span class="invalid-feedback">
                            {{errorMsgs.password}}
                        </span>
                        <input dusk="newAccountPassword" type="password" class="form-control" v-model="password" :class="{'has-error' : errorMsgs.password}">
                    </div>
                    <div class="form-group">
                        <label for="newAccountPasswordConfirmation">{{ $t('label_confirm_password') }}</label>
                        <span class="invalid-feedback">
                            {{errorMsgs.passwordVerify}}
                        </span>
                        <input dusk="newAccountPasswordConfirmation" type="password" class="form-control" v-model="passwordVerify" :class="{'has-error' : errorMsgs.passwordVerify}">
                    </div>
                    <div class="form-group">
                        <span class="invalid-feedback">
                            {{errorMsgs.acceptanceTerms}}
                        </span>
                        <div class="d-flex">
                            <input dusk="acceptanceTerms" type="checkbox" name="acceptanceTerms" id="acceptanceTerms" v-model="acceptanceTerms">
                            <p for="acceptanceTerms">{{ $t('new_account_ive_read') }}
                                <a class="link" @click.stop.prevent="openModal('termsModal')">
                                    {{ $t('new_account_tc') }}
                                </a>
                                {{ $t('new_account_site') }} {{$t('and')}}
                                <a class="link" @click.stop.prevent="openModal('confidentialityModal')">
                                    {{ $t('new_account_pc') }}
                                </a>
                            </p>
                        </div>
                    </div>
                    <div class="">
                        <div class="text-center">
                            <van-button class="main-btn" :loading="loading" dusk="create-new-account-btn" type="primary" loading-type="spinner" loading-text="Se creeaza" v-on:click="create()">
                                {{ $t('btn_create_account') }}
                            </van-button>
                        </div>
                    </div>
                    <div class="login-wrapper">
                        <p class="text-center">
                            {{ $t('already_have_account') }}
                            <router-link :to="{name: 'login'}">
                                {{ $t('btn_login') }}
                            </router-link>
                        </p>
                    </div>
                </div>
                <div class="text-center alert mt-3" v-if="status" :class="{'alert-danger': status == -1, 'alert-success': status == 1}">
                    <span v-html="message"></span>
                </div>
            </template>
            <template v-if="message.length">
                <div class="text-center alert alert-success">
                    {{message}}
                </div>
            </template>
        </div>

        <div class="modal" id="termsModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('terms')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <terms :in-modal="true"></terms>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="f_agreeTC()">
                            {{ $t('btn_i_understand') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="confidentialityModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('new_account_pc')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <confidentiality :in-modal="true"></confidentiality>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="f_agreePC()">
                            {{ $t('btn_i_understand') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import { mapActions } from 'vuex';
import TCPCModal from '../snippets/TCPCModal.vue';

export default {
    name: 'NewAccount',
    mixins: [
        TCPCModal
    ],
    components: {
         Heading
    },
    props: {
    },
    data: function() {
        return {
            message: '',
            status: 0,
            loading: false,
            email: '',
            phone: '',
            password: '',
            passwordVerify: '',
            acceptanceTerms: false,
            acceptancePolicy: false,
            errorMsgs: {
                email: '',
                password: '',
                phone: '',
                passwordVerify: '',
                acceptanceTerms: '',
                acceptancePolicy: '',
            }
        }
    },
    methods: {

        ...mapActions('user', {
            registerUserAction: 'registerUser'
        }),

        validateForm() {
            var ok = true;

            if(!this.email) {
                ok = false;
                this.errorMsgs.email = this.$t('mandatory');
            }
            else {
                this.errorMsgs.email = '';
            }

            if(!this.password) {
                ok = false;
                this.errorMsgs.password = this.$t('mandatory');
            }
            else {
                this.errorMsgs.password = '';
            }

            if(!this.passwordVerify) {
                ok = false;
                this.errorMsgs.passwordVerify = this.$t('mandatory');
            }
            else {
                this.errorMsgs.passwordVerify = '';
            }

            if(!this.phone) {
                ok = false;
                this.errorMsgs.phone = this.$t('mandatory');
            }
            else {
                this.errorMsgs.phone = '';
            }

            if(!this.acceptanceTerms) {
                ok = false;
                this.errorMsgs.acceptanceTerms = this.$t('new_account_must_accept_tc');
            }
            else {
                this.errorMsgs.acceptanceTerms = '';
            }

            return ok;
        },

        async create() {

            this.loading = true;
            //resetting message alert
            this.status = 0;

            let ok = this.validateForm();
            if (ok) {
                let user = {
                    'email': this.email,
                    'password': this.password,
                    'password_confirmation': this.passwordVerify,
                    'phone': this.phone
                };
                try {
                    let response = await this.registerUserAction(user);

                    this.message = response.data.message;
                    this.status = 1;
                    this.loading = false;
                }
                catch(error) {
                    let errors = JSON.parse(error.response.data.error.error_msg);
                    for(let i in errors) {
                        this.errorMsgs[i] = errors[i][0];
                    }

                    this.loading = false;
                }
            }
            else {
                this.loading = false;
            }
        },

        async validateEmail() {
            if(!this.email.length) {
                this.errorMsgs.email = this.$t('mandatory');
                return;
            }

            try {
                await this.$axios.post('/user/check_email_validity', {
                    'email': this.email
                }).then(() => {
                    this.errorMsgs.email = '';
                });
            }
            catch(error) {
                this.errorMsgs.email = error.response.data.error.error_msg;
            }
        },

        validatePhone() {
            let regex = RegExp('[0-9]{10}');
            if(!this.phone.length) {
                this.errorMsgs.phone = this.$t('mandatory');
                return;
            }
            else if(!regex.test(this.phone)) {
                this.errorMsgs.phone = this.$t('invalid_tel')
                return;
            }
        },

        clearErrors(type) {
            this.errorMsgs[type] = '';
        }
    }
}
</script>

<style lang="scss" scoped>
    $lightgrey: lightgrey;
    $green: #59af54;
    .page-wrapper {
        padding-top: 126px;
        padding-bottom: 114px;
        @media only screen and (max-width: 768px) {
            padding-top: 46px;
            padding-bottom: 61px;
        }
    }

    .register-wrapper {
        border-radius: 6px;
        background-color: #FFFEFD;
        padding: 36px 50px;
        max-width: 500px;
        margin: 0 auto;

        @media only screen and (max-width: 768px) {
            padding: 36px 20px;
            margin: 0px -18px;
        }

        label {
            font-size: 18px !important;
            font-weight: 500 !important;
        }

        input {
            height: 50px;
            background: #FFFEFD;
        }

        p {
            font-weight: 500;
            font-size: 14px;
            margin-bottom: 40px;
            margin-top: 4px;

            a {
                font-weight: 500;
                font-size: 14px;
                padding: 0px;
            }
        }
        input[type="checkbox"]{
            max-height: 37px !important;
            min-width: 23px !important;
            margin: 0px 8px 0 0;
        }
        .login-wrapper{
            p{
                margin-bottom: 0 !important;
                font-size: 18px;
                a{
                    font-size: 18px;
                    font-weight: bold;
                }
            }
        }
        .main-btn{
            margin-bottom: 40px;

            @media only screen and (min-width: 769px) {
                max-width: 220px;
            }
        }
    }

</style>
